// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog_c1dceb4e {
  max-height: 100vh;
  max-width: 100vw;
  background-color: #fff;
  box-shadow: 0 8px 9px 0 rgba(0,0,0,0.24), 0 1px 8px 0 rgba(0,0,0,0.12);
  border: 1px solid #dce1e5;
  border-radius: 0.333em;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
}
.dialog-overlay_c1dceb4e {
  display: flex;
  align-items: center;
  justify-content: center;
  inset: 0;
  z-index: 80;
  background-color: rgba(0,0,0,0.3);
}
.dialog-header_c1dceb4e {
  border-bottom: 1px solid #dce1e5;
}
.dialog-header__title_c1dceb4e {
  font-size: 1.334rem;
  line-height: 2.167rem;
}
.dialog-footer_c1dceb4e {
  border-top: 1px solid #dce1e5;
}
.dialog-step-wrapper_c1dceb4e {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.dialog-step_c1dceb4e {
  width: 100%;
}
.dialog-step_animate-left-enter_c1dceb4e {
  transform: translateX(100%);
}
.dialog-step_animate-left-enter-active_c1dceb4e {
  transform: translateX(0);
  transition: transform 300ms ease-in-out;
}
.dialog-step_animate-right-enter_c1dceb4e {
  transform: translateX(-100%);
}
.dialog-step_animate-right-enter-active_c1dceb4e {
  transform: translateX(0);
  transition: transform 300ms ease-in-out;
}
.dialog-step_animate-top-enter_c1dceb4e {
  transform: translateY(-100%);
}
.dialog-step_animate-top-enter-active_c1dceb4e {
  transform: translateY(0);
  transition: transform 300ms ease-in-out;
}
.dialog-step_animate-bottom-enter_c1dceb4e {
  transform: translateY(100%);
}
.dialog-step_animate-bottom-enter-active_c1dceb4e {
  transform: translateY(0);
  transition: transform 300ms ease-in-out;
}
.dialog-main_c1dceb4e {
  overflow: auto;
  display: grid;
  grid-template-rows: 1fr;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `dialog_c1dceb4e`,
	"dialog-overlay": `dialog-overlay_c1dceb4e`,
	"dialog-header": `dialog-header_c1dceb4e`,
	"dialog-header__title": `dialog-header__title_c1dceb4e`,
	"dialog-footer": `dialog-footer_c1dceb4e`,
	"dialog-step-wrapper": `dialog-step-wrapper_c1dceb4e`,
	"dialog-step": `dialog-step_c1dceb4e`,
	"dialog-step_animate-left-enter": `dialog-step_animate-left-enter_c1dceb4e`,
	"dialog-step_animate-left-enter-active": `dialog-step_animate-left-enter-active_c1dceb4e`,
	"dialog-step_animate-right-enter": `dialog-step_animate-right-enter_c1dceb4e`,
	"dialog-step_animate-right-enter-active": `dialog-step_animate-right-enter-active_c1dceb4e`,
	"dialog-step_animate-top-enter": `dialog-step_animate-top-enter_c1dceb4e`,
	"dialog-step_animate-top-enter-active": `dialog-step_animate-top-enter-active_c1dceb4e`,
	"dialog-step_animate-bottom-enter": `dialog-step_animate-bottom-enter_c1dceb4e`,
	"dialog-step_animate-bottom-enter-active": `dialog-step_animate-bottom-enter-active_c1dceb4e`,
	"dialog-main": `dialog-main_c1dceb4e`
};
export default ___CSS_LOADER_EXPORT___;
